export enum APIRoutes {
  ARTICLES_RSS_FEED = "/api/artigos/rss",
  PODCAST_RSS_FEED = "/api/podcasts/rss/[uid]",
}
